export default {
  // Sandbox
  MEMBER: 'Member',
  OWNER: 'Owner',
  VIGIL_SANDBOX_TITLE: 'Interactive Sandbox',
  WORK_EMAIL: 'Your work email',
  MEMBER_ROLE: 'Which role would you like to explore as?',
  TEXT1: `Curious if this is worth your time? Pop your email below and watch how Vigil can save you time. Always remember, you've got bigger things to code!`
}
